export const keywordsType = [{
  value: '',
  label: 'Broad match',
},
{
  value: '::exact',
  label: 'Exact match',
}];
